import { render } from "./SidebarScrollIndicator.vue?vue&type=template&id=24d978e2"
import script from "./SidebarScrollIndicator.vue?vue&type=script&lang=js"
export * from "./SidebarScrollIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__